import { __ } from '@wordpress/i18n';
import { useState, useRef, useEffect } from '@wordpress/element';
import { Button } from '@wordpress/components';
import { ColorPicker } from '@wordpress/components';
// import './style.scss';

const FlatColorPicker = ({ color = '', value = '', onChange, label }) => {
    // Use the value prop if provided, otherwise use the color prop
    const initialColor = value !== undefined ? value : color;
    
    // Use state to track the current color value
    const [currentColor, setCurrentColor] = useState(initialColor);
    const [isOpen, setIsOpen] = useState(false);
    const popupRef = useRef(null);
    const inputRef = useRef(null);

    // Update internal state when props change
    useEffect(() => {
        // Use the value prop if provided, otherwise use the color prop
        const newColor = value !== undefined ? value : color;
        setCurrentColor(newColor);
    }, [color, value]);

    // Input değeri değiştiğinde
    const handleInputChange = (e) => {
        const newValue = e.target.value;
        
        // Geçerli bir renk kodu ise
        if (/^#[0-9A-Fa-f]{6}$/.test(newValue)) {
            setCurrentColor(newValue);
            onChange(newValue);
        }
    };

    // Renk seçici açıldığında
    const openColorPicker = () => {
        setIsOpen(true);
    };

    // Renk seçildiğinde
    const handleColorChange = (newColor) => {
        const hexColor = newColor.hex;
        setCurrentColor(hexColor);
        onChange(hexColor);
    };

    // Rengi sıfırla
    const resetColor = () => {
        setCurrentColor('');
        onChange('');
    };

    // Dışarı tıklandığında popup'ı kapat
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="flat-color-picker kanews-control-item">
            {label && (
                <label className="flat-color-picker-label">
                    {label}
                </label>
            )}
            <div 
                className="color-preview" 
                style={{ backgroundColor: currentColor || 'transparent' }}
            />
            <div className="color-input">
                <input 
                    ref={inputRef}
                    type="text" 
                    value={currentColor}
                    onChange={handleInputChange}
                />
            </div>
            <div className="color-picker-actions">
                <Button 
                    className="color-picker-button"
                    onClick={openColorPicker}
                >
                    {__('Renk Seç', 'kanews')}
                </Button>
                {currentColor && (
                    <Button 
                        className="color-reset-button components-button is-small is-secondary"
                        onClick={resetColor}
                        isSmall
                    >
                        {__('Sıfırla', 'kanews')}
                    </Button>
                )}
            </div>
            
            {isOpen && (
                <div className="flat-color-picker-popup" ref={popupRef}>
                    <ColorPicker
                        color={currentColor}
                        onChangeComplete={handleColorChange}
                    />
                </div>
            )}
        </div>
    );
};

export default FlatColorPicker; 